import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-minesweeper',
  templateUrl: './minesweeper.component.html',
  styleUrls: ['./minesweeper.component.css']
})
export class MinesweeperComponent implements OnInit {
  // @ViewChild('window') windowElement!: ElementRef;
  // @Output() close = new EventEmitter<void>();

  gridSize: number = 10;
  mineCount: number = 20;
  flagCount: number = 0;
  grid: any[][] = [];
  gameOver: boolean = false;
  gameWon: boolean = false;
  gameStarted: boolean = false;
  isFlag: boolean = false; 
  touchEnd: boolean = false;
  tFlag: boolean = false;
  rCell: boolean = false;

  tRow: number;
  tCol: number;

  // private isDragging = false;
  // private offsetX = 0;
  // private offsetY = 0;

  constructor() { }

  ngOnInit(): void {
    this.initializeGrid();
  }

  initializeGrid() {
    this.grid = [];
    this.flagCount = 0;
    for (let row = 0; row < this.gridSize; row++) {
      const rowArray = [];
      for (let col = 0; col < this.gridSize; col++) {
        rowArray.push({
          revealed: false,
          flagged: false,
          mine: false,
          adjacentMines: 0
        });
      }
      this.grid.push(rowArray);
    }
    this.gameOver = false;
    this.gameWon = false;
    this.gameStarted = false;
  }

  placeMines(firstRow: number, firstCol: number) {
    let placedMines = 0;
    while (placedMines < this.mineCount) {
      const row = Math.floor(Math.random() * this.gridSize);
      const col = Math.floor(Math.random() * this.gridSize);

      if (!this.grid[row][col].mine && !(row == firstRow && col == firstCol) && !this.isNeighbor(firstRow,firstCol,row, col)) {
        this.grid[row][col].mine = true;
        placedMines++;
      }
    }
  }

  isNeighbor(firstRow: number, firstCol: number, row: number, col: number): boolean {
    return (
      Math.abs(firstRow - row) <= 1 && Math.abs(firstCol - col) <= 1
    );
  }

  calculateAdjacentMines() {
    for (let row = 0; row < this.gridSize; row++) {
      for (let col = 0; col < this.gridSize; col++) {
        if (this.grid[row][col].mine) {
          for (let r = row - 1; r <= row + 1; r++) {
            for (let c = col - 1; c <= col + 1; c++) {
              if (r >= 0 && r < this.gridSize && c >= 0 && c < this.gridSize && !(r === row && c === col)) {
                this.grid[r][c].adjacentMines++;
              }
            }
          }
        }
      }
    }
  }

  revealCell(row: number, col: number) {
    this.rCell = true;
    this.tRow = row;
    this.tCol = col;
    setTimeout(() => {
      this.rCell = false;
    }, 2000);

    if (this.gameOver || this.grid[row][col].revealed || this.grid[row][col].flagged) {
      return;
    }
    if (!this.gameOver && !this.gameStarted) {
      this.placeMines(row, col);
      this.calculateAdjacentMines();
      this.gameStarted = true;
    }

    this.grid[row][col].revealed = true;

    // If the player reveals a mine, the game is over
    if (this.grid[row][col].mine) {
      this.gameOver = true;
      for (let r = 0; r < this.gridSize; r++) {
        for (let c = 0; c < this.gridSize; c++) {
          if (this.grid[r][c].mine && !this.grid[r][c].revealed) {
            this.grid[r][c].revealed = true;
          }
        }
      }
      return;
    }

    // If there are no adjacent mines, reveal surrounding cells
    if (this.grid[row][col].adjacentMines === 0) {
      for (let r = row - 1; r <= row + 1; r++) {
        for (let c = col - 1; c <= col + 1; c++) {
          if (r >= 0 && r < this.gridSize && c >= 0 && c < this.gridSize && !(r === row && c === col)) {
            this.revealCell(r, c);
          }
        }
      }
    }

    // Check for win condition after revealing a cell
    this.checkWinCondition();
  }

  toggleFlag(row: number, col: number) {
    this.tFlag = true;
    this.tRow = row;
    this.tCol = col;
    setTimeout(() => {
      this.tFlag = false;
    }, 2000);
    if (this.gameOver || this.grid[row][col].revealed) {
      return;
    }
    if (this.grid[row][col].flagged) {
      this.flagCount--;
    } else {
      this.flagCount++;
    }
    this.grid[row][col].flagged = !this.grid[row][col].flagged;
  }

  onTouchStart(row: number, col: number) {
    this.touchEnd = false;
    setTimeout(() => {
      if (!this.touchEnd) {
        this.isFlag = true;
        this.toggleFlag(row, col);
      }
    }, 500);
  }

  onTouchEnd(row: number, col: number) {
    this.touchEnd = true;
    if (!this.isFlag)  {
      this.revealCell(row, col);
    }
    this.isFlag = false;
  }

  checkWinCondition() {
    let revealedNonMines = 0;
    let totalNonMines = 0;

    for (let row = 0; row < this.gridSize; row++) {
      for (let col = 0; col < this.gridSize; col++) {
        if (!this.grid[row][col].mine) {
          totalNonMines++;
          if (this.grid[row][col].revealed) {
            revealedNonMines++;
          }
        }
      }
    }

    if (revealedNonMines === totalNonMines) {
      this.gameWon = true;
    }
  }

  resetGame() {
    this.initializeGrid();
  }

  getCellColor(adjacentMines: number) {
    switch (adjacentMines) {
      case 1:
        return '#05878aff';
        // return '#16293eff';
      case 2:
        return '#024b35';
        // return '#173626ff';
      case 3:
        return '#640809ff';
      case 4:
        return '#67074eff';
      case 5:
        return 'maroon';
      default:
        return '';
    }
  }

  // onMouseDown(event: MouseEvent) {
  //   this.isDragging = true;
  //   this.offsetX = event.clientX - this.windowElement.nativeElement.getBoundingClientRect().left;
  //   this.offsetY = event.clientY - this.windowElement.nativeElement.getBoundingClientRect().top;
  // }

  // onMouseMove(event: MouseEvent) {
  //   if (this.isDragging) {
  //     const left = event.clientX - this.offsetX;
  //     const top = event.clientY - this.offsetY;
  //     this.windowElement.nativeElement.style.left = `${left}px`;
  //     this.windowElement.nativeElement.style.top = `${top}px`;
  //   }
  // }

  // onMouseUp() {
  //   this.isDragging = false;
  // }

  // closeWindow() {
  //   this.close.emit();
  // }

}
